import images from "../acssets/img";

export const Chefs = [
  {
    name: "Minh nghiêm",
    img: `${images.minhnghiem}`,
    link: "https://www.facebook.com/ngoc.thai.9081",
    textLink: "www.facebook.com/ngoc.thai.001",
    YearOfBirth: 1989,
    position: "Bếp Trưởng Nhà Hàng - Hải Sản - Trọng Châu cơ sở 2",
    decription:
      "Với kinh nghiệm 20 năm trong nghề bếp luôn tự tin mang lại những món ăn và trải nghiệm tuyệt vời nhất cùng khách hàng. Nhận nấu cỗ từ 1 - 500 mâm Uy tín - Phục vụ - Chuyên nghiệp...",
    addressRestaurant: "Số 347 - Ngô Quyền - Thành Phố - Hải Dương",
    telephone: "0356102688",
    nativeLand: "Tứ Kỳ",
  },
  {
    name: "Xuân Quỳnh",
    img: `${images.xuanquynh}`,
    link: "https://www.facebook.com/profile.php?id=100079099230886",
    textLink: "  facebook.com/xuan.quynh.002",
    YearOfBirth: 1988,
    position: "Từng Là Bếp Trưởng Nhà Hàng Bảo Ngọc",
    decription:
      "Xuân Quỳnh là 1 chuyên gia trong nghành công nghiệp thực phẩm nhà hàng đến với Xuân Quỳnh thì quý khách yên tâm 100%. Uy tín làm lên thương hiệu. Cam kết phát hiện đồ ăn không ngon Quỳnh luôn hoàn tiền 100% cho quý khách... ",
    addressRestaurant: "Số 322 - Ngô Quyền - Thành Phố - Hải Dương",
    telephone: "0988119985",
    nativeLand: "Gia Lộc",
  },
  {
    name: "Hoàng Quỳnh",
    img: `${images.hoangquynh}`,
    link: "https://www.facebook.com/quynh.hoangvan.733",
    textLink: "facebook.com/quynh.hoangvan.003",
    YearOfBirth: 1987,
    position: "Bếp Phó Nhà hàng Song Anh Royal 4*",
    decription:
      "Với kinh nghiệm làm việc lâu năm tại nhà hàng 4* Hoàng Quỳnh luôn cam kết mang tới cho khách hàng những món ăn mới lạ nhất, chỉnh chu nhất, bắt mắt nhất, ngon nhất...",
    addressRestaurant:
      "Số 6 Nguyễn Công Hòa, phường Hải Tân, Hải Dương, Vietnam ",
    telephone: "0977204448",
    nativeLand: "Nam Sách",
  },
  {
    name: "Đình Minh",
    img: `${images.dinhminh}`,
    link: "https://www.facebook.com/profile.php?id=100004643085405",
    textLink: "facebook.com/dinh.minh.004",
    YearOfBirth: 1998,
    position: "Đầu Bếp Chuyên Đặc Sản Rươi Tứ Ký",
    addressRestaurant: "Chí Minh - Tứ Kỳ - Thành Phố - Hải Dương",
    decription:
      "Chuyên cung cấp sỉ lẻ đặc sản Rươi Tứ Kỳ, nhận nấu cỗ từ 1 - 500 mâm. Bạn không biết ăn gì liên hệ ngay Đình Minh 1998 để sở hữu những món rươi ngon nhất Hải Dương. Cam kết không ngon hoàn tiền...",
    telephone: "0966824479",
    nativeLand: "Tứ Kỳ",
  },
];
